module.exports = __webpack_public_path__ + "static/media/205.39bfa595.png";